export default __webpack_public_path__ + "static/media/logo-aguaplanet.d94d7df8.png";